"use strict";

module.exports = {
    "tumbler": {
        "off": "Сүнд",
        "on": "Каб"
    }
};